import React, { useEffect } from "react";
import SubStockDesign from "./SubStockDesign";
import { Grid } from "@mui/material";
import SortContext from "context/SortContext";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { useSubStocks } from "../api/get-substocks";
import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

const SubStocks = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const name = location.state?.categoryName;

  const { selectedSortValue, sortOptions, search } = React.useContext(SortContext);
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const { filterValues } = useFilter();

  const {
    setFilterChangeCount,
    setDisplayCount,
    setFilterChangeDesignCount,
    setSearchResultCount,
    dynamicfilterCount,
    filterChangeCount,
    filterChangeDesignCount,
    setDynamicFilterCount,
    setSearchSuffix,
  } = useGlobalContext();

  // const Location = filterValues?.Location;
  const Location = filterValues?.Location?.map((location) =>
    location === "IDL" ? "Idel Inventory" : location
  ) || [];

  const stockStatus = filterValues["Stock Status"]?.[0] === "On Memo" ? "Memo" : filterValues["Stock Status"]?.[0] || "";

  const { data, isLoading, isError, error } = useSubStocks({
    categoryName: name,
    limit: 30,
    sortBy: selectedSortBY,
    sortOrder: selectedSortOrder,
    searchTerm: search,
    location: Location,
    stockStatus: stockStatus,
    // stockStatus: "All",
  });

  useEffect(() => {
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalCount);
      setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
      setSearchResultCount(data?.pages[0]?.totalCount);
    } else {
      setSearchResultCount(data?.pages[0]?.totalCount);
      setFilterChangeCount(filterChangeCount);
      setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    setSearchSuffix("Articles");
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("Designs");
    };
  }, [data]);

  // useEffect(() => {
  //   if (!location.state?.name) {
  //     navigate(location.pathname, { state: { name: [name] }, replace: true });
  //   }
  // }, []);

  if (isLoading) return <LoadingSmallCard count={20} />;
  if (isError) return <div>Error: {error?.message}</div>;

  const hasNoResults =
    search &&
    data?.pages?.every(
      (page) => !page?.subCategories?.length
    );

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}
      >
        {data?.pages?.map((page) =>
          page?.subCategories?.map((subcategory, _ind) => (
            <Grid item key={subcategory.id}>
              <SubStockDesign subcategory={subcategory} />
            </Grid>
          ))
        )}
      </Grid>

      {data?.pages?.length === 0 ||
        (!data?.pages.some((page) => page?.subCategories?.length > 0) && (
          <div
            style={{
              display: "flex",
              textAlign: "center",
              margin: "auto",
              padding: "auto",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <Background />
          </div>
        ))}
    </>
  );
};

export default SubStocks;
